import { useGallery } from '@media-ui/gallery/src/components/Gallery/GalleryHooks';
import * as T from './useShowGallery.types';
import { getItemsWithSourcePrefix } from './useShowGallery.utils';
export const useExtractedGalleries = ({ initialExtractedGalleries, galleryProps, articleID, }: T.IUseExtractedGalleries) => {
    const extractedGalleryIndicies: T.IExtractedGalleryIndicies = {};
    const extractedGalleries = initialExtractedGalleries.reduce<T.IExtractedGalleries>((acc, { galleryId, items }) => {
        items.forEach((picture) => {
            extractedGalleryIndicies[picture.id] = galleryId;
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        acc[galleryId] = useGallery(`Gallery-extract${galleryId}-${articleID}`, {
            galleryProps: {
                ...galleryProps,
                items: getItemsWithSourcePrefix(items),
            },
        }).show;
        return acc;
    }, {});
    return { extractedGalleries, extractedGalleryIndicies };
};
